import { Card, Flex } from "antd"
import { Typography } from "antd"
import { IProject } from "../types/project.type"
import PrimaryAsin from "../ui/PrimaryAsin"
import AsinsKeywordsCount from "../ui/AsinsKeywordsCount"
import ProjectImage from "./ProjectImage"
import useNavigateToProjectData from "../hooks/useNavigateToProjectData"

const { Title } = Typography

const ProjectTable: React.FC<{ project: IProject }> = ({ project }) => {
  const primaryAsin = project.asins.find((asin) => asin.isPrimary)
  const navigateToProjectData = useNavigateToProjectData()

  return (
    <Card
      onClick={() => navigateToProjectData(project._id)}
      cover={<ProjectImage imageUrl={primaryAsin?.imageUrl || project.asins[0].imageUrl} />}
      hoverable
    >
      <Flex vertical gap={4}>
        <Title level={5}>{project.title}</Title>
        <PrimaryAsin countryCode={project.countryCode} asin={primaryAsin?.asin} />
        <AsinsKeywordsCount
          asinsCount={project.asins.length}
          keywordsCount={project.keywords.length}
        />
      </Flex>
    </Card>
  )
}

export default ProjectTable
